import React, { useState, useCallback } from 'react';
import { object, number, array } from 'yup';
import { Formik, Form } from 'formik';
import { useHistory, useLocation } from 'react-router-dom';

import { env, meta } from '~/commons/config';
import useQuery from '~/commons/hooks/useQuery';
import useHttpStatus from '~/commons/hooks/useHttpStatus';

// import Tabs from '../../app/components/layout/Tabs.jsx';
// import Articles from './Articles.jsx';
import FieldsQuestions from '~/app/components/forms/FieldsQuestions.jsx';
import FormHttpSaveBtn from '~/commons/components/FormHttpSaveBtn.jsx';
import FormHttpBtn from '~/commons/components/FormHttpBtn.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';
import NewLines from '~/commons/components/Newlines.jsx';
import { numToLetter } from '~/commons/helpers';
import _ from 'lodash';

const schema = object({
  answers: array().of(
    object({
      answered: number().when('format', {
        is: 'single-select',
        then: number().required(),
      }),
      answeredSeq: array()
        .when('format', {
          is: 'multi-select',
          then: array()
            .of(number())
            .min(1)
            .required(),
        })
        .when('format', {
          is: 'ordering',
          then: array()
            .of(number().required())
            .required()
            .test(
              'Duplicates',
              (v) => uniq(v).length === v.length,
            ),
        })
        .when('format', {
          is: 'matching',
          then: array()
            .of(number().required())
            .required()
            .test(
              'Duplicates',
              (v) => uniq(v).length === v.length,
            ),
        }),
    }),
  ),
});

const numChar = (i) => (String(i + 101).substring(1));

const ResultBox = ({
  result,
  className,
}) => (result ? (
    <div className={className}>
      {result.marked.find((m) => m.isCorrect == false) ? (
      <>
        <div className="result d-flex flex-column justify-content-center align-items-center mx-auto p-3">
          <img src="assets/img/result-img.png"/>
          <div className="p-2 text-center result-text">
            你獲得了<span className="score">{result.correctCount}/{result.marked.length}</span>分。
            請繼續努力，點擊<a href="./little-challenge">“再挑戰一次”</a>吧!
            </div>
        </div>
        <div className="d-flex justify-content-center">
          <a href="./little-challenge"><img src="assets/img/try-again-btn.png"/></a>
        </div>
      </>
      ) : (
      <>
        <div className="result d-flex flex-column justify-content-center align-items-center mx-auto p-3">
          <img src="assets/img/full-mark.png"/>
          <div className="p-2 text-center result-text">
          '太棒了，恭喜你獲得滿分！'
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <a href="./little-challenge"><img src="assets/img/try-again-btn.png"/></a>
        </div>
      </>
      )}
    </div>
) : null);

const QuestionWithResult = ({
  questions,
  result,
}) => (result ? (
    <div className="px-3 px-lg-4 px-xl-5 readable">
      {questions.map((q, i) => {
        const marked = result.marked.find((m) => (m.question == q._id));
        return (
          <div key={i} className="card-body">
            <div className="row text-secondary">
              <h5 className="col-auto pr-0 question-num">
                {numChar(i)}
              </h5>
              <h5 className="col pl-2 question-text">
                <NewLines>{q.question}</NewLines>
              </h5>
            </div>
            {q.img && (
              <div className="py-3 text-center question-image">
                <img src={q.img} />
              </div>
            )}
            {q.choices.map(({ c, ii }, jj) => (
              <div key={ii} className="mb-2 question-choose">
                <div className={`result-check${marked.answered == ii ? ' answered' : ''}${marked.answer == ii ? ' answer' : ''}${marked.answered == ii && marked.isCorrect ? ' correct' : ''}`}>
                  <label className={'result-check-label'}>{numToLetter(jj, true)}. {c}</label>
                </div>
              </div>
            ))}
          </div>
        );
      })}
      <div className="d-flex justify-content-center">
        <a href="./little-challenge"><img src="assets/img/try-again-btn.png"/></a>
      </div>
    </div>
) : null);

const PageLittleChallenge = () => {
  const defaultKey = Object.keys(env.subjects)[0];
  console.log({ env });
  const { challenge } = env;// .slice(0,2);

  const history = useHistory();
  const { subject: q } = useQuery();
  const loc = useLocation();
  const subject = q || defaultKey;
  const [submitRes, submitReq] = useHttpStatus();
  const [questions] = useState(_.map(challenge, (q) => ({
    ...q,
    choices: q.choices.map((c, ii) => ({ c, ii, r: Math.random() })).sort((a, b) => a.r - b.r),
  })));
  const [result, setResult] = useState(null);

  // const defaults = initFormValues({
  //   answers: questions.map((q) => ({
  //     question: q._id,
  //     answered: answer
  //       ? (answer.answers.find((a) => a.question === q._id) || {}).answered
  //       : undefined,
  //   })),
  // });

  // check asnwer submit
  const submit = useCallback(async (values) => {
    // make the request
    const { status, payload } = await submitReq({
      url: 'api/quiz/answers/challenge',
      method: 'post',
      data: values,
    });
    console.log({ status, payload });
    if (status === 'success') {
      setResult({
        ...payload,
        correctCount: payload.marked.filter((m) => m.isCorrect).length,
      });
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
  }, []);

  meta.set({ title: '小挑戰' });

  return (
    <div>
      <div className="container little-challenge-container py-0 py-md-4">
        <div className="row no-gutters little-challenge-box">
          <div className="col">
            <div className='d-flex align-items-center justify-content-center'><img src="assets/img/little-challenge.png"/></div>
            <ResultBox
              className="d-flex pt-5 flex-column"
              result={result}
            />
            <QuestionWithResult
              questions={questions}
              result={result}
            />
            { !result && (
            <Formik
              validationSchema={schema}
              initialValues={{
                answers: challenge.map((q) => ({
                  question: q._id,
                  answered: undefined,
                  answeredSeq: [],
                })),
              }}
              onSubmit={submit}
            >
              {({
                values, dirty, isValid, ...props
              }) => (
              <Form>
                <FieldsQuestions
                  numChar={(i) => (String(i + 101).substring(1))}
                  questions={questions}
                />
                <div className="d-flex justify-content-center">
                  <FormHttpBtn
                    type="submit"
                    res={submitRes}
                    // className="btn-primary btn-block py-3"
                    disabled={!dirty || !isValid}
                  >
                    <img src="assets/img/show-answer-button.png"/>
                  </FormHttpBtn>
                  {/* <button className="btn">
                    <img src="assets/img/show-answer-button.png"/>
                  </button> */}
                </div>
              </Form>
              )}
            </Formik>
            )}
          </div>
          {/* <div className="col d-none d-md-flex justify-content-center">
            <ResultBox
              result={result}
              className="d-none d-sm-flex flex-column"
            />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default PageLittleChallenge;
